module.exports = __webpack_public_path__ + "static/media/up.8ac239a7.svg";